// Override Settings
var boostPFSInstantSearchConfig = {
  search: {

  }
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function (suggestionElement, searchElement, searchBoxId) {
    if (!suggestionElement) suggestionElement = this.$uiMenuElement;
    if (!searchElement) searchElement = this.$element;
    if (!searchBoxId) searchBoxId = this.id;
  };

  BoostPFS.prototype.beforeBuildSearchBox = function (id) {
    // Remove theme's instant search events
    var cloneSearchBar = jQ(id).clone();
    jQ(id).replaceWith(cloneSearchBar);

    if (Utils.InstantSearch.isFullWidthMobile()) {
      jQ(id).removeAttr('autofocus');
      if (jQ(id).is(':focus')) {
        jQ(id).blur();
      }
    }
  };

  BoostPFS.prototype.afterCloseSuggestionMobile = function (searchBoxId, isCloseSearchBox) {
    closeBoostPfsMobileThemeSearch();
  };

  BoostPFS.prototype.afterCloseInstantSearchMobile = function (searchBoxId, isCloseSearchBox) {
    closeBoostPfsMobileThemeSearch();
  };

  function closeBoostPfsMobileThemeSearch() {
    if (!jQ('.mobile-search').length) {
      return;
    }

    jQ('.mobile-search').hide();
    jQ('.mobile-search .search__results-wrapper').hide();
    jQ('.search__fields input, .mobile-search input[data-q]').blur();
    jQ('body').attr('style', '');
    jQ('body').removeClass('boost-pfs-search-suggestion-mobile-open boost-pfs-search-suggestion-open-body');
    jQ('.boost-pfs-search-suggestion-mobile, .boost-pfs-search-suggestion-mobile-top-panel, .boost-pfs-search-suggestion-mobile-overlay').hide();

    if (window.PXUTheme && window.PXUTheme.predictiveSearch) {
      suppressThemeMobileSearchOpen(1000);
    }

    if (window.PXUTheme && window.PXUTheme.predictiveSearch && typeof window.PXUTheme.predictiveSearch.hideMobileSearch === 'function') {
      window.PXUTheme.predictiveSearch.hideMobileSearch(0);
    } else {
      jQ('body').css('max-height', 'none');
      document.body.style.position = '';
      document.body.style.top = '';
    }

  }

  function suppressThemeMobileSearchOpen(duration) {
    if (!window.PXUTheme || !window.PXUTheme.predictiveSearch) {
      return;
    }

    if (!window.PXUTheme.predictiveSearch._boostPfsOriginalShowMobileSearch) {
      window.PXUTheme.predictiveSearch._boostPfsOriginalShowMobileSearch = window.PXUTheme.predictiveSearch.showMobileSearch;
    }

    window.PXUTheme.predictiveSearch._boostPfsMobileSearchSuppressed = true;
    window.PXUTheme.predictiveSearch.showMobileSearch = function () {
      return false;
    };

    clearTimeout(window.PXUTheme.predictiveSearch._boostPfsMobileSearchSuppressTimer);
    window.PXUTheme.predictiveSearch._boostPfsMobileSearchSuppressTimer = setTimeout(function () {
      restoreThemeMobileSearchOpen();
    }, duration);
  }

  function restoreThemeMobileSearchOpen() {
    if (!window.PXUTheme || !window.PXUTheme.predictiveSearch) {
      return;
    }

    if (window.PXUTheme.predictiveSearch._boostPfsOriginalShowMobileSearch) {
      window.PXUTheme.predictiveSearch.showMobileSearch = window.PXUTheme.predictiveSearch._boostPfsOriginalShowMobileSearch;
      delete window.PXUTheme.predictiveSearch._boostPfsOriginalShowMobileSearch;
    }
    window.PXUTheme.predictiveSearch._boostPfsMobileSearchSuppressed = false;
    clearTimeout(window.PXUTheme.predictiveSearch._boostPfsMobileSearchSuppressTimer);
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest('.boost-pfs-search-btn-close-suggestion');
    if (target) {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeBoostPfsMobileThemeSearch();
      suppressThemeMobileSearchOpen(1000);
    }
  }, true);

  document.addEventListener('touchstart', function (e) {
    var target = e.target.closest('.boost-pfs-search-btn-close-suggestion');
    if (target) {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeBoostPfsMobileThemeSearch();
      suppressThemeMobileSearchOpen(1000);
    }
  }, true);

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);
    var self = this;
    
    jQ('.header__link.action-area__link').off('click').click(function(e) {
      e.preventDefault();
      jQ('.search__fields input').focus();
      self.openSuggestionStyle3();
      jQ('.js-search-popup').addClass('boost-hidden');
    });

    jQ(document).off('click', '.boost-pfs-search-btn-close-suggestion').on('click', '.boost-pfs-search-btn-close-suggestion', function (e) {
      if (!isScreenSizeLarge()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeBoostPfsMobileThemeSearch();
      }
    });
  }
})();